import React from 'react';
import { InnerNavMenu } from './InnerNavMenu';
import aboutUsbanner from '../../assets/images/aboutUs.jpg'
import Whychoose from "../../assets/images/rightimg.jpg";
function AboutUs() {
    return (
        <div id='target'>
            <InnerNavMenu />
            <div className="aboutus_Banner">
                <div className="container BreadcrumbContent">
                    <h1>About Us</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">About Us</li>
                        </ol>
                    </nav></div>
                <img src={aboutUsbanner} className="img-fluid" alt='About Us' />
            </div>
         
        <div className="m-4 " id="mainSection">
          <div className="container">
            <div className="row">
              
              <div className="col-md-9 whychooseusnew">
                <h1>Why Krishi Mapper?</h1>
                <div className="barWhite"></div>
                <ul className="content">
                  <li>
                  To develop unified and uniform land intervention database for different schemes
                  </li>
                  <li>
                  For capturing of geo-coordinates and polygons of  farmer's land for evidence based decision monitoring
                  </li>
                  <li>
                    To maintain data standardization and uniformity across schemes
                  </li>
                  <li>
                  To develop an integrated platform to view all land based scheme related data on a single window
                  </li>
                  <li>
                  For data analytics and visualisation of land based scheme related data 
                  </li>
               
                </ul>
              </div>
              <div className="col-md-3 p-0 chooseimg">
                {" "}
                <img src={Whychoose} className="img-fluid" alt="why.png" />
              </div>

            </div>
          </div>
        </div>
            <div className="container-fluid copyright py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 text-center  mb-3 mb-md-0">
                            Website Content Owned & Managed by Department of Agriculture & Farmers Welfare | MoA&FW | Government of India, India

                        </div>
                        <div className="col-md-12 col-sm-12 text-center">
                            Designed and Developed by DAD/IT, Ministry of Agriculture, New Delhi, India.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default AboutUs